export const updateResponsive = (responsive) => ({
    type: 'UPDATE_RESPONSIVE',
    payload: responsive
});

export const resetResponsive = () => ({
    type: 'RESET_RESPONSIVE'
});